// extracted by mini-css-extract-plugin
export default {"last-seen":"xRyc9Qxo+r","lastSeen":"xRyc9Qxo+r"};